import {
  CUSTOMER_STATUS_LOST,
  CUSTOMER_STATUS_ON_HOLD_NURTURE,
} from 'api/customerCockpitProfileApi';
import { PIPELINE_STAGE_ORDER } from 'pages/Cockpit/Pipeline/pipelineHelpers';

export const CUSTOMER_STATUS_UNSPECIFIED = 'Unspecified';

export const CUSTOMER_STATUS_FILTER_OPTIONS = PIPELINE_STAGE_ORDER.map(
  (status) => ({ value: status, label: status })
);

const DEFAULT_EXCLUDED_CUSTOMER_STATUSES = new Set([
  CUSTOMER_STATUS_UNSPECIFIED,
  CUSTOMER_STATUS_LOST,
  CUSTOMER_STATUS_ON_HOLD_NURTURE,
]);

export const DEFAULT_CUSTOMER_STATUS_FILTER = PIPELINE_STAGE_ORDER.filter(
  (status) => !DEFAULT_EXCLUDED_CUSTOMER_STATUSES.has(status)
);

export function customerPipelineStatus(customer) {
  return customer?.pipelineStatus || CUSTOMER_STATUS_UNSPECIFIED;
}

function matchesCustomerSearch(customer, query) {
  return (
    (customer.companyName || '').toLowerCase().includes(query) ||
    (customer.name || '').toLowerCase().includes(query) ||
    (customer.id || '').toLowerCase().includes(query) ||
    (customer.users || []).some((user) =>
      (user.email || '').toLowerCase().includes(query)
    )
  );
}

export function filterCustomers({
  customers = [],
  tenantFilter = 'All',
  statusFilter = DEFAULT_CUSTOMER_STATUS_FILTER,
  searchValue = '',
} = {}) {
  let filtered = customers;

  if (tenantFilter !== 'All') {
    filtered = filtered.filter((customer) => customer.tenant === tenantFilter);
  }

  const query = searchValue.trim().toLowerCase();
  if (query) {
    return filtered.filter((customer) => matchesCustomerSearch(customer, query));
  }

  const selectedStatuses = new Set(statusFilter || []);
  return filtered.filter((customer) =>
    selectedStatuses.has(customerPipelineStatus(customer))
  );
}
